import { filter, find, forEach, isNil, size, toLower } from 'lodash'

import { AI_INGREDIENT_MATCH_TYPE } from '../constants'

import findWordIndexInDraftJsText from './find-word-index-in-draftjs-text'

const handleAiHighlightStrategy =
  (words, textBlocksWithIndexes) => (contentBlock, callback) => {
    if (words) {
      let inputText = contentBlock.getText()

      const currentBlock = find(
        textBlocksWithIndexes,
        block => block.text === inputText,
      )

      const wordsWithPriority = filter([
        ...filter(
          words,
          word => word.matchType !== AI_INGREDIENT_MATCH_TYPE.ALREADY_FOUND,
        ),
        ...filter(
          words,
          word => word.matchType === AI_INGREDIENT_MATCH_TYPE.ALREADY_FOUND,
        ),
      ])

      forEach(
        // in case we receive the input text split in multiple blocks
        // we filter out words that are not part of the current block
        filter(wordsWithPriority, word => {
          if (size(textBlocksWithIndexes) === 1 || isNil(word.startIndex)) {
            return true
          }

          return (
            word.startIndex >= currentBlock?.startIndex &&
            word.startIndex < currentBlock?.endIndex
          )
        }),
        word => {
          let formattedWord = toLower(word.word)

          if (isNil(word.word) && !isNil(word.posIndex)) {
            formattedWord = inputText.substring(
              word.posIndex[0],
              word.posIndex[1],
            )
          }

          const start = findWordIndexInDraftJsText(
            inputText,
            formattedWord,
            size(textBlocksWithIndexes) === 1 ? word.startIndex : 0,
          )

          if (start > -1) {
            callback(start, start + size(formattedWord))
            // Mark aleady used parts of text with XXXx so that the same word gets a diffrent index
            inputText = `${inputText.substring(0, start)}${'X'.repeat(
              size(formattedWord),
            )}${inputText.substring(
              start + size(formattedWord),
              size(inputText),
            )}`
          }
        },
      )
    }
  }

export default handleAiHighlightStrategy
